exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ArticleComments__commentInput___Ceb61 {\n  width: 100%;\n  border: 1px solid #ddd;\n  padding: 4px 8px;\n  border-radius: 3px;\n}\n.ArticleComments__comments___2uqrG {\n  margin-bottom: 5px;\n}\n.ArticleComments__comment___zKeYk {\n  margin-bottom: 5px;\n}\n", ""]);
// Exports
exports.locals = {
	"commentInput": "ArticleComments__commentInput___Ceb61",
	"comments": "ArticleComments__comments___2uqrG",
	"comment": "ArticleComments__comment___zKeYk"
};